/**
 * File: useQueryProviderController.ts
 * Path: apps/admin/src/modules/app/hooks/useQueryProviderController.ts
 * Description: Creates the one TanStack Query client for the app, once per mount.
 */

import { useState } from "react";
import { createQueryClient } from "@/modules/app/queryClientUtils";

export const useQueryProviderController = () => {
  const [queryClient] = useState(createQueryClient);
  return { queryClient };
};
